import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-contactus",
  templateUrl: "./contactus.component.html",
  styleUrls: ["./contactus.component.scss"]
})
export class ContactusComponent implements OnInit {
  lang: string;
  showMessage: boolean = false;
  isSuccesfull: boolean = false;

  constructor(private base: BaseService) {}

  ngOnInit() {
    this.lang = this.base.getLang();

    // -------   Mail Send ajax

    $(document).ready(function() {
      var form = $("#myForm"); // contact form
      var button = $(".contacts-us button");
      var submit = $(".contacts-us .submit-btn"); // submit button
      var onsubmit = $(".contacts-us .loading-btn"); // submit button
      var alert = $(".alert-msg"); // alert div for show alert message

      onsubmit.fadeOut("fast");

      // form submit event
      form.on("submit", function(e) {
        e.preventDefault(); // prevent default form submit
        button.attr("disabled", true);

        $.ajax({
          url: "mail.php", // form action url
          type: "POST", // form submit method get/post
          dataType: "html", // request type html/json/xml
          data: form.serialize(), // serialize form data
          beforeSend: function() {
            // alert.fadeOut();
            if (submit.css("display") != "none") {
              submit.css("display", "none");
              onsubmit.fadeIn();
            }
          },
          success: function(data) {
            // alert.html(data).fadeIn();
            // fade in response data
            $(".contacts-us .alert.alert-success").fadeIn();
            form.trigger("reset"); // reset form
          },
          error: function(e) {
            $(".contacts-us .alert.alert-danger").fadeIn();
          },
          complete: function() {
            if (onsubmit.css("display") != "none") {
              onsubmit.css("display", "none");
              submit.fadeIn(function() {
                button.attr("disabled", false);
              });
            }
          }
        });
      });
    });
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
    var submit = $(".contacts-us .submit-btn"); // submit button
    var onsubmit = $(".contacts-us .loading-btn"); // submit button
    var button = $(".contacts-us button");

    if (onsubmit.css("display") != "none") {
      onsubmit.css("display", "none");
      submit.fadeIn(function() {
        button.attr("disabled", false);
      });
    }
  }
}
